'use-strict';
gsap.registerPlugin(ScrollTrigger);

const body = document.body,
      na = navigator;
let   wide = false,
      touch = false,
      loaded = false,
      isAnimating = false,
      isSlide = false,
      swiper,
      swiperDesc;
const header = document.querySelector('header'),
      nav = document.querySelector('.nav-toggle'),
      drawer = document.querySelector('.drawer'),
      bg = document.querySelector('.bg'),
      overlay = bg.querySelector('.overlay-path'),
      container = document.querySelector('.container'),
      heroWrap = document.querySelector('.hero-wrapper'),
      hero = document.querySelector('.hero'),
      footer = document.querySelector('.footer');

const isTouchDevice = () => {
  (na.maxTouchPoints > 0 && window.ontouchstart !== undefined || window.matchMedia('(hover: none) and (pointer: coarse)').matches) ? touch = true : touch = false;
  (touch) ?  body.classList.add('touch') : body.classList.remove('touch');
}
const setFillHeight = () => {
  let cw = window.innerWidth;
  let vh = window.innerHeight * 0.01;
  if (cw == window.innerWidth) return;
  cw = window.innerWidth;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  (window.matchMedia('(min-width:960px)').matches) ? wide = true : wide = false;
  (wide) ? body.classList.add('wide') : body.classList.remove('wide');
}

const resizeFillHeight = (timer, delay) => {
  clearTimeout(timer);
  timer = setTimeout(setFillHeight, delay);
}


const onResize = ()=> {
  let timeoutID = 0;
  let delay = 500;
  window.addEventListener('resize', () => resizeFillHeight(timeoutID, delay), false);
}

const cookieConsent = () => {
  const cookieConsent = document.querySelector('.cookie-consent'),
        cookieAgree = document.querySelector('.cookie-agree'),
        cookieReject = document.querySelector('.cookie-reject'),
        cookieClose = document.querySelector('.cookie-close');

  const rejectFlag = sessionStorage.getItem('rejectFlag');
  const cookieData = document.cookie;
  let cookieSetFlag = false;

  const cookieDataList = cookieData.split('; ');
  for (const cookie of cookieDataList) {
      const cookieSplit = cookie.split('=');
      if (cookieSplit[0] === 'robotama-cookie') cookieSetFlag = true;
  }

  const expire = 30;

  function SetCookie(expire){
      const current = new Date();
      expire = current.getTime() + expire * 24 * 3600 * 1000;
      document.cookie = `robotama-cookie=robotama-read; expire=${expire}`;
  }
  function DeleteAllCookie(){
      const maxAgeZero = 'max-age=0';
      for (const cookie of cookieDataList) {
          const cookieSplit = cookie.split('=');
          document.cookie = `${cookieSplit[0]}=; ${maxAgeZero}`;
      }
  }

  function PopupDisplay(){
      cookieConsent.classList.add('is-show');
  }

  if (!cookieSetFlag &&!rejectFlag) {
    PopupDisplay();
  }

  cookieAgree.addEventListener('click', () => {
      cookieConsent.classList.add('hide');
      SetCookie(expire);
  });

  cookieReject.addEventListener('click', () => {
    cookieConsent.classList.add('hide');
    sessionStorage.setItem('rejectFlag', true);
    DeleteAllCookie();
  });

  cookieClose.addEventListener('click', () => {
    cookieConsent.classList.add('hide');
  })
}

const anchorScroll = () => {
  const easing = t => 1 - (1 - t) * (1 - t);
  const duration = 750;
  const anchors = document.querySelectorAll('a[href^="#"]');
  anchors.forEach( anchor => {
    anchor.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const href = anchor.getAttribute('href');
      const currentPos = document.documentElement.scrollTop || body.scrollTop;
      const targetElement = document.getElementById(href.replace('#', ''));
      if (targetElement) {
        const targetPos = window.pageYOffset + targetElement.getBoundingClientRect().top;
        const start = window.performance.now();
        const loop = now => {
          const time = now - start;
          const normalized = time / duration;
          if (normalized < 1) {
            window.scrollTo(0, currentPos + ((targetPos - currentPos) * easing(normalized)));
            window.requestAnimationFrame(loop);
          } else {
            window.scrollTo(0, targetPos);
          }
        };
        window.requestAnimationFrame(loop);
      }
    });
  });
};

const easeInExpo = (x) => { return x === 0 ? 0 : Math.pow(2, 10 * x - 10); }
const easeOutExpo = (x) => { return x === 1 ? 1 : 1 - Math.pow(2, -10 * x); }
const easeInOutExpo = (x) => { return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2; }
const easeInQuart = (x) => { return x * x * x * x; }
const easeOutQuart = (x) => { return 1 - Math.pow(1 - x, 4); }
const easeInOutQuart = (x) => { return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2; }

const heroSlider = () => {
  if (!hero) return;
  swiperDesc = new Swiper('.hero-desc', {
    parallax: true,
    slidesPerView: 1,
  })
  const options = {
    //effect: 'fade',
    loop: true,
    speed: 500,
    parallax: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    breakpoints: {
      960: {
        speed: 800,
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      spaceBetween: 40,
      renderBullet: (index, className) => {
        return (
          '<div class="' + className + '"><button class="swiper-pagination-btn" type="button" roll="tab"></button><div class="fraction" data-fraction="' + (Number(index) + 1) + '"><svg viewBox="0 0 24 24"><circle class="fraction-circle" cx="50%" cy="50%" r="11"></circle><circle class="inner-circle" cx="50%" cy="50%" r="11"></circle></svg></div></div>'
        )
      }
    },
    navigation: {
      prevEl: '.swiper-prevarea',
      nextEl: '.swiper-nextarea'
    },
    thumbs: {
      swiper: swiperDesc
    }
  }
  swiper = new Swiper(hero, options);
  isSlide = true;
}

const slidePause = () => {
  if (!swiper) return;
  swiper.autoplay.pause();
  const fraction = document.querySelector('.swiper-pagination-bullet-active .fraction .inner-circle');
  fraction.style.animationPlayState = 'paused';
}
const slideResume = () => {
  if (!swiper) return;
  swiper.autoplay.resume();
  const fraction = document.querySelector('.swiper-pagination-bullet-active .fraction .inner-circle');
  fraction.style.animationPlayState = 'running';
}

const headerFixed = () => {
  gsap.to(header, {
    scrollTrigger: {
      trigger: '.contents',
      start: '160px top',
      end: 'bottom 75%',
      onEnter: () => {
        header.classList.add('is-fixed');
        if(!swiper) return;
        slidePause();
        isSlide = false;
      },
      onLeaveBack: () => {
        header.classList.remove('is-fixed');
        if(!swiper && !isSlide) return;
        slideResume();
        isSlide = true;
      },
      onLeave: () => {
        header.classList.add('is-hidden');
      },
      onEnterBack: () => {
        header.classList.remove('is-hidden');
      }
    }
  });
}

const heroReveal = () => {
  if (!hero) return;
  gsap.to(hero, {
    y: '-50%',
    ease: "power1.in",
    scrollTrigger: {
      trigger: heroWrap,
      scrub: 1,
      pin: true,
      end: 'bottom top',
      markers: true
    },
  });
}

const siteLoader = () => {
  const loader = document.querySelector('.loader'),
        progressWrap = loader.querySelector('.progress-wrap'),
        progressBar = progressWrap.querySelector('.progress'),
        progressFront = progressWrap.querySelector('.progress-front'),
        progressBack = progressWrap.querySelector('.progress-back'),
        progressCountWrap = progressWrap.querySelector('.progress-count-wrap'),
        progressCounter = progressWrap.querySelector('.progress-count'),
        logo = loader.querySelector('.loader-logo');
        swiper = document.querySelector('.swiper-wrapper');
  const destroyLoader = () => {
    gsap.set(swiper, { y: '-5%', scale: 1.1, opacity: .5 });
    const tl = gsap.timeline();
    tl.fromTo(progressWrap, { y: 0 }, { y: '-100%', ease:'power4.inOut', duration: 1.6, onStart: () => {
        gsap.fromTo(progressFront, { scaleY: 1 }, { scaleY: 0, ease: 'power1.in', duration: 1 }),
        gsap.fromTo(progressBack, { scaleY: 1 }, { scaleY: 0, ease: 'power2.in', duration: 1.2, delay: .1 }),
        gsap.to(logo, { opacity: 0, duration: .1, delay: .7 }),
        gsap.to(progressCountWrap, { opacity: 0, duration: .3, delay: .6 })
        gsap.to(swiper, { y: 0, scale: 1, opacity: 1, duration: 1, delay: 1 });
      }, onComplete: () => {
        gsap.to(loader, { opacity: 0, y: '-100%', duration: .5 });
        heroSlider();
      }
    });
  }
  const loadAnimation = () => {
    const imgLoaded = imagesLoaded('.container');
    const imagesTotal = imgLoaded.images.length;
    let loadedCount = 0,
        loadingProgress = 0;
    let tlProgress = gsap.timeline();
    gsap.set(logo, { opacity: 1 });
    gsap.set(progressBar, { scaleY: 0 });
    gsap.set(progressCounter, { opacity: 1 });
    imgLoaded.on('progress', () => loadProgress());
    const loadProgress = () => {
      loadedCount++;
      loadingProgress = (loadedCount / imagesTotal);
      gsap.to(tlProgress, {progress: loadingProgress});
    }
    const progressUpdate = () => {
      let newPercent = (tlProgress.progress() * 100).toFixed();
      progressCounter.innerHTML = newPercent;
    }
    tlProgress = gsap.timeline({
      paused: true,
      onUpdate: progressUpdate,
      onComplete: destroyLoader,
      defaults: {
        duration: 1.6,
        ease: 'circ.inOut',
      },
    });
    tlProgress.to(progressBar, 1, {scaleY: 1});
  }
  const getStorage = () => window.sessionStorage.getItem('loading') ? destroyLoader() : (setStorage(), loadAnimation());
  const setStorage = () => window.sessionStorage.setItem('loading', 'done');
  const init = () => getStorage();
  init();
};

const magicCursor = () => {
  if (touch) return;
  const logo = document.querySelector('.branding');
  const wrap = document.querySelector('.cursor-wrapper');
  const cursor = wrap.querySelector('.cursor');
  const ball = cursor.querySelector('.ball');
  const cursorLine = cursor.querySelector('.cursor-line');

  const pos = {x: window.innerWidth / 2, y: window.innerHeight / 2};
  const mouse = {x: pos.x, y: pos.y};
  const speed = 0.2;
  const cursorSetX = gsap.quickSetter(cursor, 'x', 'px');
  const cursorSetY = gsap.quickSetter(cursor, 'y', 'px');
  let hoverFlg = false;
  gsap.set(cursor, {xPercent: -50, yPercent: -50, scale: .5, opacity: .5});
  window.addEventListener('mousemove', e => {
    mouse.x = e.pageX;
    mouse.y = e.pageY;
  });
  const updateCursor = () => {
    (hoverFlg) ? cursor.classList.add('is-hover') : cursor.classList.remove('is-hover');
    const ratio = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
    pos.x += (mouse.x - pos.x) * ratio;
    pos.y += (mouse.y - pos.y -window.scrollY) * ratio;
    cursorSetX(pos.x.toFixed(1));
    cursorSetY(pos.y.toFixed(1));
  };
  gsap.ticker.add(updateCursor);

  const magnetCall = (e, wrap) => {
    magnetElem(e, wrap, wrap.querySelector('.mg-element'), 20);
  };
  const magnetElem = (e, wrap, elem, tick) => {
    const rect = wrap.getBoundingClientRect();
    const posX = e.pageX - rect.left;
    const posY = e.pageY - rect.top;
    const toX = (posX - rect.width / 2) / rect.width * tick;
    const toY = (posY - rect.height / 2 - window.scrollY) / rect.height * tick;
    gsap.to(elem, {x: toX, y: toY, duration: .2, ease: 'power2.easeOut'});
  }
  const magnetCursor = (e, wrap, tick) => {
    const rect = wrap.getBoundingClientRect();
    const posX = e.pageX - rect.left;
    const posY = e.pageY - rect.top;
    const toX = rect.left + rect.width / 2 + (posX - rect.width / 2) / tick;
    const toY = rect.top + rect.height / 2 + (posY - rect.height / 2 - window.scrollY) / tick;
    gsap.to(cursor, {x: toX, y: toY, duration: .2});
  }

  const magnetLogo = el => {
    const inner = el.querySelector('.mg-element');
    el.addEventListener('mouseenter', () => {
      gsap.to(cursor, {opacity: 0, duration: .3});
      gsap.ticker.remove(updateCursor);
    });
    el.addEventListener('mouseleave', () => {
      gsap.to(cursor, {opacity: .5, duration: .3});
      gsap.to(inner, {x: 0, y: 0, duration: .3});
      gsap.ticker.add(updateCursor);
    });
    el.addEventListener('mousemove', e => {
      magnetCall(e, el);
    });
  }
  const magnetMenu = el => {
    el.forEach( (tgt) => {
      const inner = tgt.querySelector('.mg-element');
      tgt.addEventListener('mouseenter', () => {
        wrap.classList.add('is-hover');
        tgt.classList.add('is-hover');
        gsap.to(cursor, {scale: 1.25, opacity: 1, duration: .3});
        gsap.to(ball, {strokeWidth: 1, duration: .3});
        gsap.to(tgt, {scale: 1.5, duration: .3});
        gsap.to(inner, {scale: 0.75, duration: .3});
        gsap.ticker.remove(updateCursor);
      });
      tgt.addEventListener('mouseleave', () => {
        hoverFlg = false;
        wrap.classList.remove('is-hover');
        tgt.classList.remove('is-hover');
        gsap.to(ball, {strokeWidth: 2, opacity: 1, duration: .3});
        gsap.to(tgt, {scale: 1, duration: .3});
        gsap.to(inner, {x: 0, y: 0, scale: 1, duration: .3});
        gsap.to(cursor, {scale: .5, opacity: .5, duration: .3});
        gsap.ticker.add(updateCursor);
      });
      tgt.addEventListener('mousemove', e => {
        magnetCursor(e, tgt, 2);
        magnetCall(e, tgt);
      })
    })
  }
  const magnetLarge = el => {
    el.forEach( (tgt) => {
      const inner = tgt.querySelector('.mg-element');
      tgt.addEventListener('mouseenter', () => {
        hoverFlg = true;
        wrap.classList.add('is-hover');
        tgt.classList.add('is-hover');
        gsap.to(cursor, {scale: 1, opacity: 1, duration: .3});
        gsap.to(ball, {strokeWidth: 1, duration: .3});
        gsap.to(tgt, {scale: 1.5, duration: .3});
        gsap.to(inner, {scale: 0.75, duration: .3});
        gsap.ticker.remove(updateCursor);
      });
      tgt.addEventListener('mouseleave', () => {
        hoverFlg = false;
        wrap.classList.remove('is-hover');
        tgt.classList.remove('is-hover');
        gsap.to(ball, {strokeWidth: 2, duration: .3});
        gsap.to(tgt, {scale: 1, duration: .3});
        gsap.to(inner, {x: 0, y: 0, scale: 1, duration: .3});
        gsap.to(cursor, {scale: .5, opacity: .5, duration: .3});
        gsap.ticker.add(updateCursor);
      });
      tgt.addEventListener('mousemove', e => {
        magnetCursor(e, tgt, 2);
        magnetCall(e, tgt);
      })
    });
  };
  const magnetSmall = el => {
    el.forEach( (tgt) => {
      const inner = tgt.querySelector('.mg-element');
      tgt.addEventListener('mouseenter', () => {
        tgt.classList.add('is-hover');
        gsap.to(cursor, {scale: 1, opacity: 1, duration: .3});
        gsap.to(ball, {strokeWidth: 0, fill: '#fff', duration: .3});
        gsap.to(tgt, {scale: 1.25, duration: .3});
        gsap.to(inner, {scale: 0.8, duration: .3});
        gsap.ticker.remove(updateCursor);
      });
      tgt.addEventListener('mouseleave', () => {
        hoverFlg = false;
        tgt.classList.remove('is-hover');
        gsap.to(ball, {strokeWidth: 2, fill: 'none', duration: .3});
        gsap.to(tgt, {scale: 1, duration: .3});
        gsap.to(inner, {x: 0, y: 0, scale: 1, duration: .3});
        gsap.to(cursor, {scale: .5, opacity: .5, duration: .3});
        gsap.ticker.add(updateCursor);
      });
      tgt.addEventListener('mousemove', e => {
        magnetCursor(e, tgt, 2);
        magnetCall(e, tgt);
      })
    })
  }
  const magnetText =  el => {
    el.forEach( (tgt) => {
      const innerText = tgt.dataset.cursorText;
      tgt.addEventListener('mouseenter', () => {
        hoverFlg = true;
        tgt.classList.add('is-hover');
        wrap.classList.add('noblend');
        cursorLine.textContent = innerText;
        gsap.to(cursor, {scale: 1.5, opacity: 1, duration: .3});
        gsap.to(ball, {strokeWidth: 0, opacity: .9, duration: .3});
        gsap.to(cursorLine, {scale: .5, duration: .3});
      });
      tgt.addEventListener('mouseleave', () => {
        hoverFlg = false;
        tgt.classList.remove('is-hover');
        wrap.classList.remove('noblend');
        gsap.to(ball, {strokeWidth: 2, opacity: 1, duration: .3});
        gsap.to(cursorLine, {scale: 1, duration: .3});
        gsap.to(cursor, {scale: .5, opacity: .5, duration: .3});
        cursorLine.textContent = '';
      });
    })
  }

  magnetLogo(logo);
  const cursorMenu = document.querySelectorAll('[data-cursor-menu]');
  magnetMenu(cursorMenu);
  const cursorLarge = document.querySelectorAll('[data-cursor-large]');
  magnetLarge(cursorLarge);
  const cursolSmall = document.querySelectorAll('[data-cursor-small]');
  magnetSmall(cursolSmall);
  const cursorText = document.querySelectorAll('[data-cursor-text]');
  magnetText(cursorText);

}

const menuToggle = () => {
  let flag = false;
  let ww, wh;
  const openMenu = () => {
    if ( isAnimating ) return;
    ww = window.innerWidth,
    wh = window.innerHeight;
    isAnimating = true;
    gsap.timeline({
      onStart: () => {
        if (swiper && isSlide) {
          swiper.autoplay.pause();
          const fraction = document.querySelector('.swiper-pagination-bullet-active .fraction .inner-circle');
          fraction.style.animationPlayState = 'paused';
        }
        drawer.classList.add('is-active');
        body.classList.add('is-fixed');
      },
      onComplete: () => {
        nav.classList.add('is-active');
        isAnimating = false;
      }
    })
    .set(overlay, {attr: { d: 'M0 1 Q0.5 1 1 1 v0 Q0.5 1 0 1 Z' }})
    .to(overlay, {duration: .5, ease: 'power2.in', attr: { d: 'M0 0.25 Q0.5 0 1 0.25 v0.75 Q0.5 1 0 1 Z' }})
    .to(overlay, {duration: .3, ease: 'power2.out', attr: { d: 'M0 0 Q0.5 0 1 0 v1 Q0.5 1 0 1 Z' }})
    /*
    .set(bg, {clipPath: 'inset(100% 0px 0px)'})
    .to(bg, {duration: .5, ease: 'power2.inOut', clipPath: 'inset(1px 0px 0px)'})
    .set(bg, {clipPath: 'inset(0px)'});
    */
  }
  const closeMenu = () => {
    if ( isAnimating ) return;
    ww = window.innerWidth,
    wh = window.innerHeight;
    isAnimating = true;
    gsap.timeline({
      onComplete: () => {
        isAnimating = false;
        body.classList.remove('is-fixed');
        drawer.classList.remove('is-active');
        nav.classList.remove('is-active');
        if (swiper && isSlide) {
          swiper.autoplay.resume();
          const fraction = document.querySelector('.swiper-pagination-bullet-active .fraction .inner-circle');
          fraction.style.animationPlayState = 'running';
        }
      }
    })
    .set(overlay, {attr: { d: 'M0 0 Q0.5 0 1 0 v1 Q0.5 1 0 1 Z' }})
    .to(overlay, {duration: .5, ease: 'power2.in', attr: { d: 'M0 0 Q0.5 0 1 0 v0.25 Q0.5 0.5 0 0.25 Z' }})
    .to(overlay, {duration: .3, ease: 'power2.out', attr: { d: 'M0 0 Q0.5 0 1 0 v0 Q0.5 0 0 0 Z' }})
  }
  nav.addEventListener('click', (e) => {
    if ( isAnimating ) return;
    e.preventDefault();
    flag ? closeMenu() : openMenu();
    flag = !flag;
  });
}

const drawStripe = () => {
  const collection = document.querySelector('.stripe-effect');
  if (!collection) return;
  gsap.set(collection, { opacity: 0 });
  gsap.to(collection, {
    opacity: 1,
    duration: .6,
    scrollTrigger: {
      target: collection,
      start: 'top 90%',
    }
  });
  const wrap = collection.querySelectorAll('.stripe-image-wrap');
  wrap.forEach((item) => {
    gsap.to(item, {
      stagger: {
        from: 'start',
        each: 0.5
      },
      scrollTrigger: {
        trigger: item,
        start: '50% bottom',
      },
      onStart: () => {
        viewStripe();
      }
    });
    const img = item.querySelector('.stripe-image');
    const w = img.getBoundingClientRect().width;
    const h = img.getBoundingClientRect().height;
    const image = new Image();
    image.src = item.querySelector('img').src;
    const rw = image.naturalWidth;
    const rh = image.naturalHeight;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.classList.add('stripe-canvas');
    canvas.width = w;
    canvas.height = h;
    item.appendChild(canvas);
    image.addEventListener('load', () => {
      ctx.drawImage(image, 0, rh - 1, rw, 1, 0, 0, w, h);
    });
    const viewStripe = () =>  {
      const duration = 1000;
      const distance = rh;
      const start = performance.now();
      const draw = () => {
        const timestamp = performance.now();
        const elapsed = start ? timestamp - start : 0;
        const progress = easeInExpo(Math.min(1, elapsed / duration));
        const xh = Math.floor(distance * progress);
        if (elapsed < duration) {
          //ctx.clearRect(0, 0, canvas.width, canvas.height);
          dh = Math.floor(h - (xh * h / distance));
          sh = Math.floor(rh - xh - 1);
          ctx.drawImage(image, 0, 0, w, h);
          ctx.drawImage(image, 0, sh, rw, 1, 0, 0, w, dh);
          requestAnimationFrame(draw);
        } else {
          img.classList.add('is-show');
          canvas.remove();
        }
      }
      draw();
    }
  });
}


const videoPlay = () => {
  const catchMovie = document.querySelectorAll('.top-video');
  if (!catchMovie) return;
  catchMovie.forEach((video) => {
    gsap.to(video, {
      scrollTrigger: {
        trigger: video,
        scroller: '.container',
        start: 'top 75%',
        end: 'bottom top',
        onEnter: () => video.play(),
        onEnterBack: () => video.play(),
        onLeave: () => video.pause(),
        onLeaveBack: () => video.pause(),
      }
    });
  });
}

const inView = (el) => {
  if (el === null) return;
  const scrollTarget = Array.prototype.slice.call(el);
  const options = {
    root: null,
    rootMargin: '0px 0px -25% 0px',
    threshold: 0
  };
  const scrollCallback = (items) => {
    items.forEach( (item, i) => {
      const target = item.target;
      if (item.isIntersecting && !target.classList.contains('inview')) {
        const delay = i * 100;
        setTimeout( () => {
          target.classList.add('inview');
        }, delay);
      } else {
        if (target.classList.contains('inview') && target.classList.contains('review')) {
          target.classList.remove('inview');
        }
      }
    });
  };
  const observer = new IntersectionObserver(scrollCallback, options);
  scrollTarget.forEach(tgt => {
    observer.observe(tgt);
  });
};

const init = () => {
  isTouchDevice();
  setFillHeight();
  onResize();
  //cookieConsent();
}

const loadInit =() => {
  headerFixed();
  anchorScroll();
  menuToggle();
  //inViewHero();
  magicCursor();
  //heroReveal();
  //videoPlay();
}

window.addEventListener('DOMContentLoaded', () => {
  init();
  //siteLoader();
  /*
  barba.init({
    transitions: [{
      name: 'opacityTransition',
      sync: true,
      leave(data) {
        return gsap.to(data.current.container, {autoAlpha: 0, duration: 0.5})
      },
      enter(data) {
        return gsap.from(data.next.container, {autoAlpha: 0, duration: 1, delay: 1})
      }
    }]
  })
  */
});

window.addEventListener('load', () => {
  loadInit();
  if (body.classList.contains('home')) {
    heroSlider();
  }
  //drawStripe();
  if (body.classList.contains('page-collections')) {
    const grids = document.querySelector('.grid');
    const grid = new Muuri('.grid', {
      items: '.card',
      layout: {
        fillGaps: true,
        rounding: false
      },
    });
    grid.layout( () => {
      console.log('layout done!');
      grids.classList.add('synched');
    });
    const sortable = document.querySelector('.sortable__nav');
    const filterBtn = sortable.querySelectorAll('.nav__link');
    filterBtn.forEach( elm => {
      elm.addEventListener('click', e => {
        e.preventDefault();
        const so  = sortable.querySelector('.is-filtered');
        so.classList.remove('is-filtered');
        elm.classList.add('is-filtered');
        const filter = elm.dataset.link;
        if (filter == 'all') {
          grid.filter('[data-category]');
        } else {
          const filterVal = '[data-category="' + filter + '"]';
          grid.filter(filterVal);
        }
      });
    });
    const tgt = document.querySelectorAll('.tgt');
    inView(tgt);
  }

});

document.addEventListener("scroll", () => {
  const images = document.querySelectorAll(".item-img");

  images.forEach((img, index) => {
    const rect = img.getBoundingClientRect();

    // 次の画像が上がってきたら前の画像をフェードアウト
    if (index > 0) {
      const prev = images[index - 1];
      if (rect.top < window.innerHeight * 0.1) {
        prev.classList.add("fade-out");
      } else {
        prev.classList.remove("fade-out");
      }
    }
  });
});